/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAliases {
  APPLICATION_BAR_0 = 'application-bar-0',
  AVATAR_USER = 'avatar-user',
  CONTEXT_MENU_0 = 'context-menu-0',
  DROP_DOWN_MENU_0 = 'drop-down-menu-0',
  DROP_DOWN_PROVIDERS = 'drop-down-providers',
  DROP_DOWN_USUARIO = 'drop-down-usuario',
  FETCH_NOTIFICATIONS = 'fetch-notifications',
  FOOTER_0 = 'footer-0',
  FRAGMENT_ACCREDITATION_UPDATE_SIDEBAR_MENU = 'fragment-accreditation-update-sidebar-menu',
  FRAGMENT_CONTRACTS = 'fragment-contracts',
  FRAGMENT_CONTRACTUAL_AMENDMENT = 'fragment-contractual-amendment',
  FRAGMENT_MESSAGES = 'fragment-messages',
  FRAGMENT_NEGOTIATION_DRAFT = 'fragment-negotiation-draft',
  FRAGMENT_NEGOTIATION_SIDEBAR_MENU = 'fragment-negotiation-sidebar-menu',
  FRAGMENT_ROUTES = 'fragment-routes',
  FRAGMENT_TECHNICAL_VISIT_APPOINTMENTS = 'fragment-technical-visit-appointments',
  FRAGMENT_TECHNICAL_VISIT_FORMS = 'fragment-technical-visit-forms',
  FRAGMENT_TECHNICAL_VISIT_INCONSISTENCIES = 'fragment-technical-visit-inconsistencies',
  HPMS_PROVIDER_OPTIONS = 'hpms-provider-options',
  IMAGE_0 = 'image-0',
  LAYOUT_MESSAGES = 'layout-messages',
  LAYOUT_PROFILES = 'layout-profiles',
  LAYOUT_PROVIDER = 'layout-provider',
  LINK_MESSAGE = 'link-message',
  LINK_SHOW_ALL_MESSAGES = 'link-show-all-messages',
  NOTIFICATION_CENTER = 'notification-center',
  OPTION_DADOS = 'option-dados',
  OPTION_DADOS_GRUPO_CONTRATUAL = 'option-dados-grupo-contratual',
  OPTION_EXIT = 'option-exit',
  OPTION_MENSAGEM = 'option-mensagem',
  OPTION_MESSAGES = 'option-messages',
  OPTION_MY_DATA = 'option-my-data',
  PANEL_0 = 'panel-0',
  PANEL_3 = 'panel-3',
  PANEL_ACCREDITATION = 'panel-accreditation',
  PANEL_ADRESS = 'panel-adress',
  PANEL_APP_ROUTES = 'panel-app-routes',
  PANEL_CNPJ = 'panel-cnpj',
  PANEL_CONTEXT_MENU_CONTRATOS = 'panel-context-menu-contratos',
  PANEL_DROPDOWN_PROVIDERS = 'panel-dropdown-providers',
  PANEL_MESSAGES = 'panel-messages',
  PANEL_NOTIFICATIONS = 'panel-notifications',
  PANEL_PROFILES = 'panel-profiles',
  PANEL_PROVIDERS = 'panel-providers',
  PANEL_ROUTES = 'panel-routes',
  PANEL_SHOW_ALL_MESSAGES = 'panel-show-all-messages',
  PANEL_TEXT_PROFILE = 'panel-text-profile',
  REPEATER_PROVIDER = 'repeater-provider',
  ROUTE_ACCREDITATION_UPDATE_SIDEBAR_MENU = 'route-accreditation-update-sidebar-menu',
  ROUTE_CONTRACT_DETAILS = 'route-contract-details',
  ROUTE_NEGOTIATION_CONTRACTUAL_AMENDMENT = 'route-negotiation-contractual-amendment',
  ROUTE_NEGOTIATION_DRAFT = 'route-negotiation-draft',
  ROUTE_NEGOTIATION_SIDEBAR_MENU = 'route-negotiation-sidebar-menu',
  ROUTE_ROUTES = 'route-routes',
  ROUTE_TECHNICAL_VISIT_APPOINTMENTS = 'route-technical-visit-appointments',
  ROUTE_TECHNICAL_VISIT_FORMS = 'route-technical-visit-forms',
  ROUTE_TECHNICAL_VISIT_INCONSISTENCIES = 'route-technical-visit-inconsistencies',
  TEXT_1 = 'text-1',
  TEXT_ADDRESS = 'text-address',
  TEXT_CNPJ = 'text-cnpj',
  TEXT_DS_ADDRESS = 'text-ds-address',
  TEXT_DS_PROVIDER = 'text-ds-provider',
  TEXT_NR_CNPJ = 'text-nr-cnpj',
  TEXT_PROFILE = 'text-profile',
}
export { ProviderAliases };
